import * as type from '../types';

const initialState = {
  beneficiaryOrganization: null,
  historyOrganization: null,
  activeRedemptions: [],
  historyRedemptions: [],
  activeTitle: '',
  activeStartDate: '',
  activeEndDate: '',
  historyTitle: '',
  historyStartDate: '',
  historyEndDate: '',
  historyStatus: ['COMPLETED', 'CANCELLED'],
  activeLoading: false,
  activeError: false,
  historyLoading: false,
  historyError: false,
  consumptionPeriod: '',
  consumptionData: [],
  consumptionDataLoading: false,
  consumptionDataError: false
};

export default function sessions(state = initialState, action) {
  switch (action.type) {
    case type.BENEFICIARY_ORGANIZATION_SELECT:
      return {
        ...state,
        beneficiaryOrganization: action.payload,
      };
    case type.HISTORY_ORGANIZATION_SELECT:
      return {
        ...state,
        historyOrganization: action.payload,
      };
    case type.SET_ACTIVE_REDEMPTIONS_TITLE:
      return {
        ...state,
        activeTitle: action.payload,
      };
    case type.SET_ACTIVE_REDEMPTIONS_START_DATE:
      return {
        ...state,
        activeStartDate: action.payload,
      };
    case type.SET_ACTIVE_REDEMPTIONS_END_DATE:
      return {
        ...state,
        activeEndDate: action.payload,
      };
    case type.SET_REDEMPTIONS_HISTORY_TITLE:
      return {
        ...state,
        historyTitle: action.payload,
      };
    case type.SET_REDEMPTIONS_HISTORY_START_DATE:
      return {
        ...state,
        historyStartDate: action.payload,
      };
    case type.SET_REDEMPTIONS_HISTORY_END_DATE:
      return {
        ...state,
        historyEndDate: action.payload,
      };
    case type.SET_REDEMPTIONS_HISTORY_STATUS:
      return {
        ...state,
        historyStatus: action.payload,
      };
    case type.ACTIVE_REDEMPTIONS_SEARCH_REQUESTED:
      return {
        ...state,
        activeLoading: true,
        activeError: false,
      };
    case type.ACTIVE_REDEMPTIONS_SEARCH_SUCCEEDED:
      return {
        ...state,
        activeRedemptions: action.payload,      
        activeLoading: false,
        activeError: false,
      };
    case type.ACTIVE_REDEMPTIONS_SEARCH_FAILED:
      return {
        ...state,
        activeRedemptions: [],
        activeLoading: false,
        activeError: true,
      };
    case type.HISTORY_REDEMPTIONS_SEARCH_REQUESTED:
      return {
        ...state,
        historyLoading: true,
        historyError: false,
      };
    case type.HISTORY_REDEMPTIONS_SEARCH_SUCCEEDED:
      return {
        ...state,
        historyRedemptions: action.payload,
        historyLoading: false,
        historyError: false,
      };
    case type.HISTORY_REDEMPTIONS_SEARCH_FAILED:
      return {
        ...state,
        historyRedemptions: [],
        historyLoading: false,
        historyError: true,
      };
    case type.SET_FILTER_CONSUMPTION_PERIOD:
      return {
        ...state,
        consumptionPeriod: action.payload,
      };
    case type.GET_CONSUMPTION_DATA_REQUESTED:
      return {
        ...state,
        consumptionDataLoading: true,
        consumptionDataError: false,
      };
    case type.GET_CONSUMPTION_DATA_SUCCEEDED:
      return {
        ...state,
        consumptionData: action.payload,
        consumptionDataLoading: false,
        consumptionDataError: false,
      };
    case type.GET_CONSUMPTION_DATA_FAILED:
      return {
        ...state,
        consumptionData: [],
        consumptionDataLoading: false,
        consumptionDataError: true,
      };
    default:
      return state;
  }
}
